module.exports = __webpack_public_path__ + "static/img/head.7cfbed81.png";